/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free fraction calculator. Add, subtract, multiply or divide two fractions and get the answer reduced to its simplest form.`)
};

const es_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita en línea de buscar y reemplazar. Reemplaza todas las ocurrencias en tu texto usando coincidencia literal o regex, con opciones de sin distinción de mayúsculas y solo palabras completas. Funciona en tu navegador.`)
};

const de_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Online-Tool zum Suchen und Ersetzen. Ersetzen Sie alle Vorkommen in Ihrem Text mit wörtlicher oder Regex-Übereinstimmung, mit Optionen für Groß-/Kleinschreibung und ganze Wörter. Funktioniert in Ihrem Browser.`)
};

const nl_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online zoeken- en vervangingshulpmiddel. Vervang alle exemplaren in uw tekst met letterlijke of regex-bijpassingen, met niet-hoofdlettergevoelige en alleen-hele-woord-opties. Werkt in uw browser.`)
};

const fr_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit en ligne de recherche et remplacement. Remplacez toutes les occurrences dans votre texte en utilisant une correspondance littérale ou regex, avec options insensibles à la casse et mot entier. Fonctionne dans votre navigateur.`)
};

const it_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento online gratuito di ricerca e sostituzione. Sostituisci tutte le occorrenze nel tuo testo utilizzando corrispondenza letterale o regex, con opzioni di ricerca senza distinzione tra maiuscole e minuscole e solo parola intera. Funziona nel tuo browser.`)
};

const pt_br2_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta online gratuita de localizar e substituir. Substitua todas as ocorrências em seu texto usando correspondência literal ou regex, com opções de distinção de maiúsculas/minúsculas e palavra completa. Funciona em seu navegador.`)
};

const pt_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta online gratuita de procura e substituição. Substitua todas as ocorrências no seu texto usando correspondência literal ou regex, com opções de insensibilidade a maiúsculas e palavras inteiras. Funciona no seu navegador.`)
};

const ja_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン検索・置換ツール。テキスト内のすべての出現を文字列または正規表現で置換でき、大文字小文字を区別しない、単語全体のみのオプションがあります。ブラウザで動作します。`)
};

const zh_fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线查找和替换工具。使用字面文本或正则表达式匹配替换文本中的所有匹配项，可选不区分大小写和仅匹配整个单词。可在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_meta_description", locale)
	if (locale === "en") return en_fr_meta_description(inputs)
	if (locale === "es") return es_fr_meta_description(inputs)
	if (locale === "de") return de_fr_meta_description(inputs)
	if (locale === "nl") return nl_fr_meta_description(inputs)
	if (locale === "fr") return fr_fr_meta_description(inputs)
	if (locale === "it") return it_fr_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_fr_meta_description(inputs)
	if (locale === "pt") return pt_fr_meta_description(inputs)
	if (locale === "ja") return ja_fr_meta_description(inputs)
	return zh_fr_meta_description(inputs)
};